export default __webpack_public_path__ + "static/icon-information-8995c7f4fda31f74d03d619cb276efd3.svg";